import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetPayoutAccountOnboardingUrlQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  returnRoute?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type GetPayoutAccountOnboardingUrlQuery = {
  __typename?: 'Query';
  getRegistryEventData?: {
    __typename?: 'EventData';
    id: string;
    payoutAccount?: { __typename?: 'RegistryPayoutAccount'; onboardingUrl?: string | null; serviceDashboardUrl?: string | null } | null;
  } | null;
};

export type InitCashFundsHostFromRegistryMutationVariables = Types.Exact<{
  input: Types.CreateCashFundsHostInput;
  returnRoute?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type InitCashFundsHostFromRegistryMutation = {
  __typename?: 'Mutation';
  initCashFundsHost:
    | { __typename?: 'CashFundGeneralError'; code: string; nativeMessage?: string | null }
    | {
        __typename?: 'CashFundsHost';
        id: string;
        payoutAccount: { __typename?: 'CashFundsPayoutAccount'; status: string; countryCode?: string | null; currencyCode: string; onboardingUrl?: string | null };
      };
};

export const GetPayoutAccountOnboardingUrlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayoutAccountOnboardingUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnRoute' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payoutAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onboardingUrl' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'params' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                { kind: 'ObjectField', name: { kind: 'Name', value: 'returnRoute' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'returnRoute' } } },
                              ],
                            },
                          },
                        ],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceDashboardUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPayoutAccountOnboardingUrlQuery__
 *
 * To run a query within a React component, call `useGetPayoutAccountOnboardingUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutAccountOnboardingUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutAccountOnboardingUrlQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      returnRoute: // value for 'returnRoute'
 *   },
 * });
 */
export function useGetPayoutAccountOnboardingUrlQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutAccountOnboardingUrlQuery, GetPayoutAccountOnboardingUrlQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetPayoutAccountOnboardingUrlQuery, GetPayoutAccountOnboardingUrlQueryVariables>(GetPayoutAccountOnboardingUrlDocument, baseOptions);
}
export function useGetPayoutAccountOnboardingUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutAccountOnboardingUrlQuery, GetPayoutAccountOnboardingUrlQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetPayoutAccountOnboardingUrlQuery, GetPayoutAccountOnboardingUrlQueryVariables>(GetPayoutAccountOnboardingUrlDocument, baseOptions);
}
export type GetPayoutAccountOnboardingUrlQueryHookResult = ReturnType<typeof useGetPayoutAccountOnboardingUrlQuery>;
export type GetPayoutAccountOnboardingUrlLazyQueryHookResult = ReturnType<typeof useGetPayoutAccountOnboardingUrlLazyQuery>;
export type GetPayoutAccountOnboardingUrlQueryResult = Apollo.QueryResult<GetPayoutAccountOnboardingUrlQuery, GetPayoutAccountOnboardingUrlQueryVariables>;
export const InitCashFundsHostFromRegistryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitCashFundsHostFromRegistry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCashFundsHostInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnRoute' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initCashFundsHost' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundsHost' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payoutAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboardingUrl' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'params' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'returnRoute' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'returnRoute' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundGeneralError' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nativeMessage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InitCashFundsHostFromRegistryMutationFn = Apollo.MutationFunction<InitCashFundsHostFromRegistryMutation, InitCashFundsHostFromRegistryMutationVariables>;

/**
 * __useInitCashFundsHostFromRegistryMutation__
 *
 * To run a mutation, you first call `useInitCashFundsHostFromRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitCashFundsHostFromRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initCashFundsHostFromRegistryMutation, { data, loading, error }] = useInitCashFundsHostFromRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *      returnRoute: // value for 'returnRoute'
 *   },
 * });
 */
export function useInitCashFundsHostFromRegistryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<InitCashFundsHostFromRegistryMutation, InitCashFundsHostFromRegistryMutationVariables>,
) {
  return ApolloReactHooks.useMutation<InitCashFundsHostFromRegistryMutation, InitCashFundsHostFromRegistryMutationVariables>(InitCashFundsHostFromRegistryDocument, baseOptions);
}
export type InitCashFundsHostFromRegistryMutationHookResult = ReturnType<typeof useInitCashFundsHostFromRegistryMutation>;
export type InitCashFundsHostFromRegistryMutationResult = Apollo.MutationResult<InitCashFundsHostFromRegistryMutation>;
export type InitCashFundsHostFromRegistryMutationOptions = Apollo.BaseMutationOptions<InitCashFundsHostFromRegistryMutation, InitCashFundsHostFromRegistryMutationVariables>;
